import { useTranslation } from 'react-i18next'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface UnassignConfirmDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    objectID: string
    objectDescription: string | null
    recoverRequestId: number | null
    onConfirm: () => void
    isLoading?: boolean
}

export function UnassignConfirmDialog({
    open,
    onOpenChange,
    objectID,
    objectDescription,
    onConfirm,
    isLoading = false,
}: UnassignConfirmDialogProps) {
    const { t } = useTranslation()
    const desc = objectDescription ? String(objectDescription).trim() : ''
    const message = t('myAssignments.unassignConfirmMessage', {
        objectID,
        objectDescription: desc ? ` ${desc}` : '',
    })

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{t('myAssignments.unassignTitle')}</DialogTitle>
                    <DialogDescription>{message}</DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        disabled={isLoading}
                    >
                        {t('common.cancel')}
                    </Button>
                    <Button
                        onClick={() => {
                            onConfirm()
                        }}
                        disabled={isLoading}
                    >
                        {isLoading ? t('common.saving') : t('common.yes')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
